export default __webpack_public_path__ + "31ca59c9730a6863d2b64d0cfb86881e.jpg";